import { render } from "./tallbutton.vue?vue&type=template&id=14edcdd4"
import script from "./tallbutton.vue?vue&type=script&lang=js"
export * from "./tallbutton.vue?vue&type=script&lang=js"

import "./tallbutton.vue?vue&type=style&index=0&id=14edcdd4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__